//
//
//
//
//
//
//
//

/**
 * section，仅添加了padding-top: 10
 */
export default {
  name: 'ListSection',
  props: {
    /**
     * 内容样式类
     */
    contentClass: {
      type: [Array, Object]
    }
  }
};